import { Lookup } from "projects/shared/src/models/lookup"
import { EvaluationTaskStatusEnum } from "./enums/EvaluationTaskStatusEnum"
import { TaskPriorityEnumValues } from "./enums/TaskPriorityEnumValues"
import { StoreTypeEnum } from "./enums/StoreTypeEnum"
import { SystemTaskTypeEnum } from "./enums/SystemTaskTypeEnum"



export class TaskDetails {
  status: Status
  priority: Priority
  taskId: number
  taskNumber: string
  duedate: Date
  branch: string
  branchLogo: string
  city: string
  website: string
  group: string
  instructions: string
  evaluation: string
  ambassadorData: AmbassadorData
  canDelete: boolean
  haveAmbassador: boolean
  trackName: string
  creationDate: Date
  updateDate: Date
  approvalDate: Date
  evaluationRequestNumber: string
  canViewEvaluationRequest: boolean
  modificationReasons: ModificationReason[]
  complianceRateAndViolation: ComplianceRateAndViolation
  economicOperatorName: string
  evaluationRequestId: number
  storeType: StoreTypeEnum
  rejectionReason: any
  assignedTaskType: SystemTaskTypeEnum
  longitude: string
  latitude: string
}

export interface Status {
  title: string
  statusCode: EvaluationTaskStatusEnum
}

export class Priority {
  id: number
  name: string
  code: TaskPriorityEnumValues
  description: any
  isSpecial: boolean
  icon: any
}


export interface AmbassadorData {
  name: string
  image: string
}

export interface ModificationReason {
  title: string
  reason: string
  date: string
  status: EvaluationTaskStatusEnum
}
export interface ComplianceRateAndViolation {
  complianceRate: any
  violiationCount: any
  complianceCategoryName: string
  complainceRateReport: ComplainceRateReport
  genrationDate: Date
}

export interface ComplainceRateReport {
  path: string
  name: string
  size: string
  extention: string
}
